export default "__VITE_ASSET__DuoOslI$__"